<div class="row">
  <div class="row-between-center flex-grow-1">
    <h2 *ngIf="title">{{ title }}</h2>
    <div *ngIf="closeable" class="close-icon-container" [class.col-24]="!title">
      <svg-icon (click)="closeDialog()" key="cancel" class="close-icon"></svg-icon>
    </div>
  </div>
  <h4 *ngIf="subtitle" class="col-22 mt-2 d-flex align-items-center subtitle">{{ subtitle }}</h4>
</div>
<ng-content></ng-content>
